<template>
  <div
    class="sb-element mb-2"
    :class="[
      item.classes.replace('px-md-0', ''),
      item.items && item.items.length > 0 ? 'px-4' : 'border py-3',
    ]"
  >
    <div v-if="item.items && item.items.length > 0" class="row">
      <button @click="remove_element" class="btn pr-0 btn-link text-danger float-right">&times;</button>
      <sb-element
        v-for="(item_, index) in item.items"
        :key="'sbelement-' + (index + Math.random())"
        :item="item_"
        @remove_element="remove_element(index)"
      ></sb-element>
    </div>
    <div v-else-if="item.type == 'table'" class="row">
      <button @click="remove_element" class="btn pr-0 btn-link text-danger float-right">&times;</button>
      <div
        class="form-group col-12 field-handle"
        :class="item.type == 'h' ? 'bg-success-light' : 'bg-light'"
        style="
          margin: -15px;
          margin-left: 0;
          margin-bottom: 15px;
          padding: 15px;
        "
      >
        <small class="d-flex align-items-center" style="gap: 10px;"
          >Type: <select class="form-control" v-model="item.type">
            <!-- <option value='product-repeater'>Повторяющийся товар</option> -->
            <option value='h'>Heading</option>
            <option value='div'>Block</option>
            <!-- <option value='table'>Табличное поле</option> -->
            <option value='v-select'>Dropdown library</option>
            <option value='tnved'>TNVED</option>
            <option value='text'>Text field</option>
            <option value='cleave'>Numeric field</option>
            <!-- <option value='address'>Адрес</option> -->
            <option value='datepicker'>Date</option>
            <option value='switch'>Switch</option>
          </select>
        </small>
      </div>
      <div class="col-12">
        <div class="px-4 row">
          <sb-element
            v-for="(item_, index) in item.options.columns"
            :key="'sbelement-' + (index + Math.random())"
            :item="item_"
            @remove_element="remove_element(index)"
          ></sb-element>
        </div>
      </div>
    </div>
    <div v-else>
      <button @click="remove_element" class="btn pr-0 btn-link text-danger float-right">&times;</button>
      <div
        class="form-group field-handle"
        :class="item.type == 'h' ? 'bg-success-light' : 'bg-light'"
        style="margin: -15px; margin-bottom: 15px; padding: 15px"
      >
        <small class="d-flex align-items-center" style="gap: 10px;"
          >Type: 
          <!-- <strong>{{ human_type(item.type) }}</strong> -->
          <select class="form-control" v-model="item.type">
            <!-- <option value='product-repeater'>Повторяющийся товар</option> -->
            <option value='h'>Heading</option>
            <option value='div'>Block</option>
            <!-- <option value='table'>Табличное поле</option> -->
            <option value='v-select'>Dropdown library</option>
            <option value='tnved'>TNVED</option>
            <option value='text'>Text field</option>
            <option value='cleave'>Numeric field</option>
            <!-- <option value='address'>Адрес</option> -->
            <option value='datepicker'>Date</option>
            <option value='switch'>Switch</option>
          </select>
        </small>
      </div>
      <div class="form-group">
        <small class="d-flex align-items-center"
          >Database column: 
          <input type="text" class="form-control form-control-sm" v-model="item.model" style="height: 30px;">
          </small
        >
      </div>
      <div class="form-group" v-if="item.type=='v-select'">
        <small class="d-flex align-items-center"
          >Data source: 
          <input type="text" class="form-control form-control-sm" v-model="item.source" style="height: 30px;">
          </small
        >
      </div>
      <div class="form-group">
        <small class="d-block"
          >Label: 
          <input type="text" class="form-control form-control-sm"  v-model="item.label_en" placeholder="EN" style="height: 30px;margin-bottom: 10px;;">
          <input type="text" class="form-control form-control-sm" v-model="item.label" placeholder="RU"  style="height: 30px;">
          </small
        >
      </div>
      <div
        class="form-group"
        v-if="item && item.options && item.options.description"
      >
        <small class="d-block"
          >Description:
          <strong>{{ trans(item.options.description) }}</strong></small
        >
      </div>
      <div class="form-group-" style="display: flex;align-items: center; gap: 20px;">
        <label class="d-flex align-items-center" style="gap: 10px"
          >Width:
          <select v-model="item.classes" class="form-control d-block">
            <option value="col-md-2">16%</option>
            <option value="col-md-3">25%</option>
            <option value="col-md-4">33%</option>
            <option value="col-md-5">41%</option>
            <option value="col-md-6">50%</option>
            <option value="col-md-12">100%</option>
          </select>
        </label>
        <label class="d-block" v-if="item.type != 'div' && item.type != 'h'">
          <input type="checkbox" v-model="item.is_filled" />
          Fillable
        </label>
        <label class="d-block" v-if="item.type != 'div' && item.type != 'h'">
          <input type="checkbox" v-model="item.is_required" />
          Required
        </label>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  watch: {
    item: {
      deep: true,
      handler() {
        this.$emit("element_change", this.item);
      },
    },
  },
  methods: {
    trans(string) {
      return this.$t(string);
    },
    remove_element() {
      this.$emit("remove_element");
    },
    human_type(type) {
      let translation = {
        "product-repeater": "Повторяющийся товар",
        h: "Заголовок",
        div: "Блок",
        table: "Табличное поле",
        "v-select": "Справочник",
        tnved: "ТНВЭД",
        text: "Текстовое поле",
        cleave: "Числовое поле",
        address: "Адрес",
        datepicker: "Дата",
        switch: "Тумблер",
      };
      return translation[type];
    },
  },
};
</script>
